const KEY = 'condi.current_condo'

export function getCurrentCondo(): number | null {
  const raw = localStorage.getItem(KEY)
  const id = raw === null ? NaN : Number(raw)
  return Number.isInteger(id) ? id : null
}

export function setCurrentCondo(id: number) {
  localStorage.setItem(KEY, String(id))
}

export function clearCurrentCondo() {
  localStorage.removeItem(KEY)
}
